import { createSlice } from "@reduxjs/toolkit";
import {
  fetchEventJournal,
  fetchKpis,
  fetchLoanAging,
  fetchPastPayments,
  fetchPortfolioAtGlance,
  fetchPortfolioAtGlanceBroker,
  fetchUpcomingPayments,
  fetchOldLoanPortfolio,
  fetchLoanCharges,
  fetchAttachments,
  fetchLAdditionalInterestSkim,
  fetchRevYTDPie,
  fetchWLTVByPropTypePie,
  fetchLoanDistByPropTypePie,
  fetchLoanAgingPie,
  fetchLoanDistByMaturityPie,
  fetchLoanDistByPriorityPie,
  fetchPAGWithFilters,
  fetchLoanDistPrinBalPie,
  fetchActiveLoanSnapShot,
  fetchPortfolioAtGlanceBrokerNew,
  fetchBorrowerTotalLoanDetails,
  fetchBorrowerDashboardPayOffDetails,
  fetchBorrowerLoanAging,
  fetchBorrowerInsuranceExpiry,
  fetchBorrowerPortfolioLoans,
  fetchBorrowerDefaultLoans,
  fetchBorrowerPastDue31Days,
  fetchBorrowerAllLoansBankDetails,
  fetchBorrowerAllAccountsLoanDetails,
  fetchBorrowerMaturingLoans,
  fetchBorrowerInsuranceExpiringWithIn30Days,
  fetchBorrowerOneTimeScheduledPayments,
  fetchBorrowerOneTimePaymentsHistory,
  fetchPayoffDemands,
  fetchPayoffDemandsDetail,
  fetchBorrowerOtherDetails,
  fetchVOMRequests,
  fetchVOMRequestDetails,
  fetchUSStates,
  fetchVOMRequestsForBorrower,
  fetchPayoffDemandsThirdParty,
} from "./api";
import { reduceSum } from "../../../Utils";
import { loadingTypes } from "../../../Utils/constant";
import { latestRequestOnly } from "./latestRequestOnly";

const initialState = {
  kpis: {
    loanCount: 0,
    portfolioBalance: 0,
    upcomingPayments: 0,
    noOfDefault: 0,
    outstandingCharges: 0,
    loanCountStatus: "idle",
    portfolioBalanceStatus: "idle",
    upcomingPaymentsStatus: "idle",
    noOfDefaulStatust: "idle",
    outstandingChargesStatus: "idle",
    status: "idle",
    loanAgingTab: 0,
  },
  pastPayments: { data: [], status: "idle" },
  loanCharges: { data: [], status: "idle" },
  attachments: { data: [], status: "idle" },
  additionalInterestSkim: { data: [], status: "idle" },
  upcomingPayments: { data: [], status: "idle" },
  eventJournal: { data: [], status: "idle" },
  portfolioAtGlance: { data: [], status: "idle" },
  pAGWithFilter: { data: [], status: "idle" },
  oldLoanPortfolio: { data: [], status: "idle" },
  revYTDPie: { data: [], status: "idle" },
  loanDistByPriorityPie: { data: [], status: "idle" },
  activeLoanSnapShot: { data: [], status: "idle" },
  loanDistByMaturityPie: { data: [], status: "idle" },
  loanAgingPie: { data: [], status: "idle" },
  loanDistByPropTypePie: { data: [], status: "idle" },
  wLTVByPropTypePie: { data: [], status: "idle" },
  loanDistPrinBalPie: { data: [], status: "idle" },
  meterDetails: [],
  pieSelected: {
    title: "Loan Distribution by Priority",
    filterKey: "priority",
    value: "1",
  },
  doughnut: {
    valuesToPopulate: [
      {
        category: "0-30",
        value: 1,
      },
      {
        category: "31-60",
        value: 1,
      },
      {
        category: "61-90",
        value: 1,
      },
      {
        category: "91+",
        value: 1,
      },
    ],
    loanAgingTable: [],
    summary: [],
    status: "idle",
  },
  languageDetected: false,
  showTermsPopup: true,
  activeLoanStatus: "active",
  borrowerTotalLoanValues: { data: [], status: "idle" },
  borrowerPayOffDetails: { data: [], status: "idle" },
  borrowerLoanAgingData: { data: [], status: "idle" },
  borrowerInsuranceExpiry: { data: [], status: "idle" },
  borrowerPortfolioLoans: { data: [], status: "idle" },
  borrowerDefaultBankruptcy: { data: [], status: "idle" },
  borrowerDefaultWorkout: { data: [], status: "idle" },
  borrowerPastDue31DaysLoans: { data: [], status: "idle" },
  borrowerAllLoansBankAccounts: { data: [], status: "idle" },
  borrowerAllAccountLoanDetails: { data: [], status: "idle" },
  borrowerMaturingLoans: { data: [], status: "idle" },
  borrowerInsuranceExpiringWithIn30Days: { data: [], status: "idle" },
  borrowerScheduledOneTimePayments: { data: [], status: "idle" },
  borrowerOneTimePaymentsHistory: { data: [], status: "idle" },
  payOffDemands: { data: [], status: "idle" },
  payOffDemandsDetail: { data: [], status: "idle" },
  smallDoughnutTableParentTab: 0,
  borrowerOtherDetails: { data: [], status: "idle" },
  vomRequests: { data: [], status: loadingTypes.idle },
  vomRequestDetail: { data: [], status: loadingTypes.idle },
  USstates: { data: [], status: loadingTypes.idle },
  borrowerVOMRequests: { data: [], status: loadingTypes.idle },
  thirdPartyPayoffRequests: {data: [], status: loadingTypes.idle},
  pendingAuthPayoffCount: 0,
  pendingLenderApproval: 0
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardStatus: (state, action) => {
      state.kpis.status = action.payload;
      state.kpis.loanCountStatus = action.payload;
      state.kpis.portfolioBalanceStatus = action.payload;
      state.kpis.upcomingPaymentsStatus = action.payload;
      state.kpis.noOfDefaulStatust = action.payload;
      state.kpis.outstandingChargesStatus = action.payload;
      state.kpis.loanAgingTab = 0;
      state.pastPayments.status = action.payload;
      state.upcomingPayments.status = action.payload;
      state.eventJournal.status = action.payload;
      state.portfolioAtGlance.status = action.payload;
      state.doughnut.status = action.payload;
      state.oldLoanPortfolio.status = action.payload;
      state.loanCharges.status = action.payload;
      state.attachments.status = action.payload;
      state.additionalInterestSkim.status = action.payload;
      state.revYTDPie.status = action.payload;
      state.loanDistByPriorityPie.status = action.payload;
      state.activeLoanSnapShot.status = action.payload;
      state.loanDistByMaturityPie.status = action.payload;
      state.loanAgingPie.status = action.payload;
      state.loanDistByPropTypePie.status = action.payload;
      state.wLTVByPropTypePie.status = action.payload;
      state.loanDistPrinBalPie.status = action.payload;
    },
    setPieSelected: (state, action) => {
      state.pieSelected = action.payload;
    },
    setMeterDetails: (state, action) => {
      state.meterDetails = action.payload;
    },
    setRevYTDPieStatus: (state, action) => {
      state.revYTDPie.status = action.payload;
    },
    resetDashboard: (state) => {
      return initialState;
    },
    setLoanAgingTab: (state, action) => {
      state.kpis.loanAgingTab = action.payload;
    },
    setLangugeDetected: (state, action) => {
      state.languageDetected = action.payload;
    },
    handleTermsPopup: (state, action) => {
      state.showTermsPopup = action.payload;
    },
    setActiveLoanStatus: (state, action) => {
      state.activeLoanStatus = action.payload;
    },
    resetAllAccountsLoanDetails: (state) => {
      state.borrowerAllAccountLoanDetails.data = [];
      state.borrowerAllAccountLoanDetails.status = loadingTypes.idle;
    },
    resetAllLoanBankDetails: (state) => {
      state.borrowerAllLoansBankAccounts.data = [];
      state.borrowerAllLoansBankAccounts.status = loadingTypes.idle;
    },
    setSmallDoughnutTableParentTab: (state, action) => {
      state.smallDoughnutTableParentTab = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchKpis.pending, (state) => {
      state.kpis.status = "loading";
    });
    builder.addCase(fetchKpis.fulfilled, (state, action) => {
      state.kpis.loanCount = action.payload.loanCount;
      state.kpis.upcomingPayments = action.payload.upcomingPayments;
      state.kpis.noOfDefault = action.payload.noOfDefault;
      state.kpis.portfolioBalance = action.payload.portfolioBalance;
      state.kpis.outstandingCharges = action.payload.outstandingCharges;
      state.kpis.status = "fulfilled";
    });
    builder.addCase(fetchKpis.rejected, (state) => {
      state.kpis.status = "failed";
    });
    builder.addCase(fetchPastPayments.pending, (state) => {
      state.pastPayments.status = "loading";
      state.pastPayments.data = [];
    });
    builder.addCase(fetchPastPayments.fulfilled, (state, action) => {
      state.pastPayments.data = action.payload;
      state.pastPayments.status = "fulfilled";
    });
    builder.addCase(fetchPastPayments.rejected, (state) => {
      state.pastPayments.status = "failed";
      state.pastPayments.data = [];
    });
    builder.addCase(fetchUpcomingPayments.pending, (state) => {
      state.upcomingPayments.status = "loading";
      // state.kpis.upcomingPayments = 0;
      // state.kpis.upcomingPaymentsStatus = "loading";
    });
    builder.addCase(fetchUpcomingPayments.fulfilled, (state, action) => {
      // state.kpis.upcomingPayments = reduceSum(
      //   action.payload.map((data) => data.Amount)
      // );
      state.upcomingPayments.data = action.payload;
      state.upcomingPayments.status = "fulfilled";
      // state.kpis.upcomingPaymentsStatus = "fulfilled";
    });
    builder.addCase(fetchUpcomingPayments.rejected, (state) => {
      state.upcomingPayments.data = [];
      // state.kpis.upcomingPayments = 0;
      state.upcomingPayments.status = "failed";
      // state.kpis.upcomingPaymentsStatus = "failed";
    });
    builder.addCase(fetchEventJournal.pending, (state) => {
      state.eventJournal.status = "loading";
    });
    builder.addCase(fetchEventJournal.fulfilled, (state, action) => {
      state.eventJournal.data = action.payload;
      state.eventJournal.status = "fulfilled";
    });
    builder.addCase(fetchEventJournal.rejected, (state) => {
      state.eventJournal.data = [];
      state.eventJournal.status = "failed";
    });
    builder.addCase(fetchPAGWithFilters.pending, (state) => {
      state.pAGWithFilter.status = "loading";
    });
    builder.addCase(fetchPAGWithFilters.fulfilled, (state, action) => {
      state.pAGWithFilter.data = action.payload;
      state.pAGWithFilter.status = "fulfilled";
    });
    builder.addCase(fetchPAGWithFilters.rejected, (state) => {
      state.pAGWithFilter.data = [];
      state.pAGWithFilter.status = "failed";
    });
    builder.addCase(fetchPortfolioAtGlance.pending, (state) => {
      state.portfolioAtGlance.status = "loading";
      // state.kpis.portfolioBalanceStatus = "loading";
      state.portfolioAtGlance.data = [];
      // state.kpis.portfolioBalance = 0;
    });
    builder.addCase(fetchPortfolioAtGlance.fulfilled, (state, action) => {
      state.portfolioAtGlance.data = action.payload;
      // state.kpis.portfolioBalance = reduceSum(
      //   action.payload?.map((data2) =>
      //     data2?.principal ? Number(data2?.principal) : 0
      //   )
      // );
      // state.kpis.portfolioBalanceStatus = "fulfilled";
      state.portfolioAtGlance.status = "fulfilled";
    });
    builder.addCase(fetchPortfolioAtGlance.rejected, (state) => {
      state.portfolioAtGlance.data = [];
      // state.kpis.portfolioBalance = 0;
      // state.kpis.portfolioBalanceStatus = "failed";
      state.portfolioAtGlance.status = "failed";
    });
    builder.addCase(fetchPortfolioAtGlanceBroker.pending, (state) => {
      // state.kpis.portfolioBalanceStatus = "loading";
      state.portfolioAtGlance.status = "loading";
      // state.kpis.portfolioBalance = 0;
    });
    builder.addCase(fetchPortfolioAtGlanceBroker.fulfilled, (state, action) => {
      state.portfolioAtGlance.data = action.payload;
      // state.kpis.portfolioBalance = reduceSum(
      //   action.payload?.map((data2) =>
      //     data2?.principal ? Number(data2?.principal) : 0
      //   )
      // );
      // state.kpis.portfolioBalanceStatus = "fulfilled";
      state.portfolioAtGlance.status = "fulfilled";
    });
    builder.addCase(fetchPortfolioAtGlanceBroker.rejected, (state) => {
      state.portfolioAtGlance.data = [];
      // state.kpis.portfolioBalance = 0;
      state.portfolioAtGlance.status = "failed";
      // state.kpis.portfolioBalanceStatus = "failed";
    });

    builder.addCase(fetchPortfolioAtGlanceBrokerNew.pending, (state) => {
      state.portfolioAtGlance.status = "loading";
    });
    builder.addCase(
      fetchPortfolioAtGlanceBrokerNew.fulfilled,
      (state, action) => {
        state.portfolioAtGlance.data = action.payload;
        state.portfolioAtGlance.status = "fulfilled";
      },
    );
    builder.addCase(fetchPortfolioAtGlanceBrokerNew.rejected, (state) => {
      state.portfolioAtGlance.data = [];
      state.portfolioAtGlance.status = "failed";
    });

    builder.addCase(fetchLoanAging.pending, (state) => {
      state.doughnut.status = "loading";
      // state.kpis.loanCount = 0;
      // state.kpis.loanCountStatus = "loading";
    });
    builder.addCase(fetchLoanAging.fulfilled, (state, action) => {
      state.doughnut.valuesToPopulate = action.payload.valuesToPopulate;
      state.doughnut.loanAgingTable = action.payload.loanAgingTable;
      // state.kpis.loanCount = reduceSum(
      //   action.payload.valuesToPopulate?.map((data) => data.value)
      // );
      state.doughnut.status = "fulfilled";
      // state.kpis.loanCountStatus = "fulfilled";
    });
    builder.addCase(fetchLoanAging.rejected, (state) => {
      state.doughnut.status = "failed";
      // state.kpis.loanCountStatus = "failed";
      // state.kpis.loanCount = 0;
    });
    builder.addCase(fetchOldLoanPortfolio.pending, (state) => {
      state.oldLoanPortfolio.status = "loading";
    });
    builder.addCase(fetchOldLoanPortfolio.fulfilled, (state, action) => {
      state.oldLoanPortfolio.data = action.payload;
      state.oldLoanPortfolio.status = "fulfilled";
    });
    builder.addCase(fetchOldLoanPortfolio.rejected, (state) => {
      state.oldLoanPortfolio.data = [];
      state.oldLoanPortfolio.status = "failed";
    });
    builder.addCase(fetchLoanCharges.pending, (state) => {
      state.loanCharges.status = "loading";
      // state.kpis.outstandingCharges = 0;
      // state.kpis.outstandingChargesStatus = "loading";
    });
    builder.addCase(fetchLoanCharges.fulfilled, (state, action) => {
      state.loanCharges.data = action.payload;
      // state.kpis.outstandingCharges = reduceSum(
      //   action?.payload?.map((data2) =>
      //     data2?.["Unpaid Balance"] ? Number(data2?.["Unpaid Balance"]) : 0
      //   )
      // );
      state.loanCharges.status = "fulfilled";
      // state.kpis.outstandingChargesStatus = "fulfilled";
    });
    builder.addCase(fetchLoanCharges.rejected, (state) => {
      state.loanCharges.data = [];
      // state.kpis.outstandingCharges = 0;
      state.loanCharges.status = "failed";
      // state.kpis.outstandingChargesStatus = "failed";
    });
    builder.addCase(fetchAttachments.pending, (state) => {
      state.attachments.status = "loading";
    });
    builder.addCase(fetchAttachments.fulfilled, (state, action) => {
      state.attachments.data = action.payload;
      state.attachments.status = "fulfilled";
    });
    builder.addCase(fetchAttachments.rejected, (state) => {
      state.attachments.data = [];
      state.attachments.status = "failed";
    });
    builder.addCase(fetchLAdditionalInterestSkim.pending, (state) => {
      state.additionalInterestSkim.status = "loading";
    });
    builder.addCase(fetchLAdditionalInterestSkim.fulfilled, (state, action) => {
      state.additionalInterestSkim.data = action.payload;
      state.additionalInterestSkim.status = "fulfilled";
    });
    builder.addCase(fetchLAdditionalInterestSkim.rejected, (state) => {
      state.additionalInterestSkim.data = [];
      state.additionalInterestSkim.status = "failed";
    });

    builder.addCase(fetchRevYTDPie.pending, (state) => {
      state.revYTDPie.status = "loading";
    });
    builder.addCase(fetchRevYTDPie.fulfilled, (state, action) => {
      state.revYTDPie.data = action.payload;
      state.revYTDPie.status = "fulfilled";
    });
    builder.addCase(fetchRevYTDPie.rejected, (state) => {
      state.revYTDPie.data = [];
      state.revYTDPie.status = "failed";
    });
    builder.addCase(fetchLoanDistByPriorityPie.pending, (state) => {
      state.loanDistByPriorityPie.status = "loading";
    });
    builder.addCase(fetchLoanDistByPriorityPie.fulfilled, (state, action) => {
      state.loanDistByPriorityPie.data = action.payload;
      state.loanDistByPriorityPie.status = "fulfilled";
    });
    builder.addCase(fetchLoanDistByPriorityPie.rejected, (state) => {
      state.loanDistByPriorityPie.data = [];
      state.loanDistByPriorityPie.status = "failed";
    });
    builder.addCase(fetchActiveLoanSnapShot.pending, (state) => {
      state.activeLoanSnapShot.status = "loading";
    });
    builder.addCase(fetchActiveLoanSnapShot.fulfilled, (state, action) => {
      state.activeLoanSnapShot.data = action.payload;
      state.activeLoanSnapShot.status = "fulfilled";
    });
    builder.addCase(fetchActiveLoanSnapShot.rejected, (state) => {
      state.activeLoanSnapShot.data = [];
      state.activeLoanSnapShot.status = "failed";
    });
    builder.addCase(fetchLoanDistByMaturityPie.pending, (state) => {
      state.loanDistByMaturityPie.status = "loading";
    });
    builder.addCase(fetchLoanDistByMaturityPie.fulfilled, (state, action) => {
      state.loanDistByMaturityPie.data = action.payload;
      state.loanDistByMaturityPie.status = "fulfilled";
    });
    builder.addCase(fetchLoanDistByMaturityPie.rejected, (state) => {
      state.loanDistByMaturityPie.data = [];
      state.loanDistByMaturityPie.status = "failed";
    });
    builder.addCase(fetchLoanAgingPie.pending, (state) => {
      state.loanAgingPie.status = "loading";
    });
    builder.addCase(fetchLoanAgingPie.fulfilled, (state, action) => {
      state.loanAgingPie.data = action.payload;
      state.loanAgingPie.status = "fulfilled";
    });
    builder.addCase(fetchLoanAgingPie.rejected, (state) => {
      state.loanAgingPie.data = [];
      state.loanAgingPie.status = "failed";
    });
    builder.addCase(fetchLoanDistByPropTypePie.pending, (state) => {
      state.loanDistByPropTypePie.status = "loading";
    });
    builder.addCase(fetchLoanDistByPropTypePie.fulfilled, (state, action) => {
      state.loanDistByPropTypePie.data = action.payload;
      state.loanDistByPropTypePie.status = "fulfilled";
    });
    builder.addCase(fetchLoanDistByPropTypePie.rejected, (state) => {
      state.loanDistByPropTypePie.data = [];
      state.loanDistByPropTypePie.status = "failed";
    });
    builder.addCase(fetchWLTVByPropTypePie.pending, (state) => {
      state.wLTVByPropTypePie.status = "loading";
    });
    builder.addCase(fetchWLTVByPropTypePie.fulfilled, (state, action) => {
      state.wLTVByPropTypePie.data = action.payload;
      state.wLTVByPropTypePie.status = "fulfilled";
    });
    builder.addCase(fetchWLTVByPropTypePie.rejected, (state) => {
      state.wLTVByPropTypePie.data = [];
      state.wLTVByPropTypePie.status = "failed";
    });
    builder.addCase(fetchLoanDistPrinBalPie.pending, (state) => {
      state.loanDistPrinBalPie.status = "loading";
    });
    builder.addCase(fetchLoanDistPrinBalPie.fulfilled, (state, action) => {
      state.loanDistPrinBalPie.data = action.payload;
      state.loanDistPrinBalPie.status = "fulfilled";
    });
    builder.addCase(fetchLoanDistPrinBalPie.rejected, (state) => {
      state.loanDistPrinBalPie.data = [];
      state.loanDistPrinBalPie.status = "failed";
    });

    builder.addCase(fetchBorrowerTotalLoanDetails.pending, (state) => {
      state.borrowerTotalLoanValues.data = [];
      state.borrowerTotalLoanValues.status = loadingTypes.loading;
    });
    builder.addCase(
      fetchBorrowerTotalLoanDetails.fulfilled,
      (state, action) => {
        state.borrowerTotalLoanValues.data = action.payload;
        state.borrowerTotalLoanValues.status = loadingTypes.fulfilled;
      },
    );
    builder.addCase(fetchBorrowerTotalLoanDetails.rejected, (state) => {
      state.borrowerTotalLoanValues.data = [];
      state.borrowerTotalLoanValues.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerDashboardPayOffDetails.pending, (state) => {
      state.borrowerPayOffDetails.status = loadingTypes.loading;
      state.borrowerPayOffDetails.data = [];
    });
    builder.addCase(
      fetchBorrowerDashboardPayOffDetails.fulfilled,
      (state, action) => {
        state.borrowerPayOffDetails.data = action.payload;
        state.borrowerPayOffDetails.status = loadingTypes.fulfilled;
      },
    );
    builder.addCase(fetchBorrowerDashboardPayOffDetails.rejected, (state) => {
      state.borrowerPayOffDetails.data = [];
      state.borrowerPayOffDetails.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerLoanAging.pending, (state) => {
      state.borrowerLoanAgingData.status = loadingTypes.loading;
      state.borrowerLoanAgingData.data = [];
    });
    builder.addCase(fetchBorrowerLoanAging.fulfilled, (state, action) => {
      state.borrowerLoanAgingData.status = loadingTypes.fulfilled;
      state.borrowerLoanAgingData.data = action.payload;
    });
    builder.addCase(fetchBorrowerLoanAging.rejected, (state) => {
      state.borrowerLoanAgingData.status = loadingTypes.failed;
      state.borrowerLoanAgingData.data = [];
    });

    builder.addCase(fetchBorrowerInsuranceExpiry.pending, (state) => {
      state.borrowerInsuranceExpiry.data = [];
      state.meterDetails = [];
      state.borrowerInsuranceExpiry.status = loadingTypes.loading;
    });
    builder.addCase(fetchBorrowerInsuranceExpiry.fulfilled, (state, action) => {
      state.borrowerInsuranceExpiry.data = action.payload.formData;
      state.meterDetails = action.payload.filteredInsuredData;
      state.borrowerInsuranceExpiry.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchBorrowerInsuranceExpiry.rejected, (state) => {
      state.borrowerInsuranceExpiry.data = [];
      state.meterDetails = [];
      state.borrowerInsuranceExpiry.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerPortfolioLoans.pending, (state) => {
      state.borrowerPortfolioLoans.data = [];
      state.borrowerPortfolioLoans.status = loadingTypes.loading;
    });
    builder.addCase(fetchBorrowerPortfolioLoans.fulfilled, (state, action) => {
      state.borrowerPortfolioLoans.data = action.payload;
      state.borrowerPortfolioLoans.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchBorrowerPortfolioLoans.rejected, (state) => {
      state.borrowerPortfolioLoans.data = [];
      state.borrowerPortfolioLoans.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerDefaultLoans.pending, (state) => {
      state.borrowerDefaultBankruptcy.data = [];
      state.borrowerDefaultWorkout.data = [];
      state.borrowerDefaultBankruptcy.status = loadingTypes.loading;
      state.borrowerDefaultWorkout.status = loadingTypes.loading;
    });
    builder.addCase(fetchBorrowerDefaultLoans.fulfilled, (state, action) => {
      state.borrowerDefaultBankruptcy.data = action.payload.loansInBankruptcy;
      state.borrowerDefaultWorkout.data = action.payload.loansInWorkout;
      state.borrowerDefaultBankruptcy.status = loadingTypes.fulfilled;
      state.borrowerDefaultWorkout.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchBorrowerDefaultLoans.rejected, (state) => {
      state.borrowerDefaultBankruptcy.data = [];
      state.borrowerDefaultWorkout.data = [];
      state.borrowerDefaultBankruptcy.status = loadingTypes.failed;
      state.borrowerDefaultWorkout.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerPastDue31Days.pending, (state) => {
      state.borrowerPastDue31DaysLoans.data = [];
      state.borrowerPastDue31DaysLoans.status = loadingTypes.loading;
    });
    builder.addCase(fetchBorrowerPastDue31Days.fulfilled, (state, action) => {
      state.borrowerPastDue31DaysLoans.data = action.payload;
      state.borrowerPastDue31DaysLoans.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchBorrowerPastDue31Days.rejected, (state) => {
      state.borrowerPastDue31DaysLoans.data = [];
      state.borrowerPastDue31DaysLoans.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerAllLoansBankDetails.pending, (state) => {
      state.borrowerAllLoansBankAccounts.data = [];
      state.borrowerAllLoansBankAccounts.status = loadingTypes.loading;
    });
    builder.addCase(
      fetchBorrowerAllLoansBankDetails.fulfilled,
      (state, action) => {
        state.borrowerAllLoansBankAccounts.data = action.payload;
        state.borrowerAllLoansBankAccounts.status = loadingTypes.fulfilled;
      },
    );
    builder.addCase(fetchBorrowerAllLoansBankDetails.rejected, (state) => {
      state.borrowerAllLoansBankAccounts.data = [];
      state.borrowerAllLoansBankAccounts.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerAllAccountsLoanDetails.pending, (state) => {
      state.borrowerAllAccountLoanDetails.data = [];
      state.borrowerAllAccountLoanDetails.status = loadingTypes.loading;
    });
    builder.addCase(
      fetchBorrowerAllAccountsLoanDetails.fulfilled,
      (state, action) => {
        state.borrowerAllAccountLoanDetails.data = action.payload;
        state.borrowerAllAccountLoanDetails.status = loadingTypes.fulfilled;
      },
    );
    builder.addCase(fetchBorrowerAllAccountsLoanDetails.rejected, (state) => {
      state.borrowerAllAccountLoanDetails.data = [];
      state.borrowerAllAccountLoanDetails.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerMaturingLoans.pending, (state) => {
      state.borrowerMaturingLoans.data = [];
      state.borrowerMaturingLoans.status = loadingTypes.loading;
    });
    builder.addCase(fetchBorrowerMaturingLoans.fulfilled, (state, action) => {
      state.borrowerMaturingLoans.data = action.payload;
      state.borrowerMaturingLoans.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchBorrowerMaturingLoans.rejected, (state) => {
      state.borrowerMaturingLoans.data = [];
      state.borrowerMaturingLoans.status = loadingTypes.failed;
    });

    builder.addCase(
      fetchBorrowerInsuranceExpiringWithIn30Days.pending,
      (state) => {
        state.borrowerInsuranceExpiringWithIn30Days.data = [];
        state.borrowerInsuranceExpiringWithIn30Days.status =
          loadingTypes.loading;
      },
    );
    builder.addCase(
      fetchBorrowerInsuranceExpiringWithIn30Days.fulfilled,
      (state, action) => {
        state.borrowerInsuranceExpiringWithIn30Days.data = action.payload;
        state.borrowerInsuranceExpiringWithIn30Days.status =
          loadingTypes.fulfilled;
      },
    );
    builder.addCase(
      fetchBorrowerInsuranceExpiringWithIn30Days.rejected,
      (state) => {
        state.borrowerInsuranceExpiringWithIn30Days.data = [];
        state.borrowerInsuranceExpiringWithIn30Days.status =
          loadingTypes.failed;
      },
    );

    builder.addCase(fetchBorrowerOneTimeScheduledPayments.pending, (state) => {
      state.borrowerScheduledOneTimePayments.data = [];
      state.borrowerScheduledOneTimePayments.status = loadingTypes.loading;
    });
    builder.addCase(
      fetchBorrowerOneTimeScheduledPayments.fulfilled,
      (state, action) => {
        state.borrowerScheduledOneTimePayments.data = action.payload;
        state.borrowerScheduledOneTimePayments.status = loadingTypes.fulfilled;
      },
    );
    builder.addCase(fetchBorrowerOneTimeScheduledPayments.rejected, (state) => {
      state.borrowerScheduledOneTimePayments.data = [];
      state.borrowerScheduledOneTimePayments.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerOneTimePaymentsHistory.pending, (state) => {
      state.borrowerOneTimePaymentsHistory.data = [];
      state.borrowerOneTimePaymentsHistory.status = loadingTypes.loading;
    });
    builder.addCase(
      fetchBorrowerOneTimePaymentsHistory.fulfilled,
      (state, action) => {
        state.borrowerOneTimePaymentsHistory.data = action.payload;
        state.borrowerOneTimePaymentsHistory.status = loadingTypes.fulfilled;
      },
    );
    builder.addCase(fetchBorrowerOneTimePaymentsHistory.rejected, (state) => {
      state.borrowerOneTimePaymentsHistory.data = [];
      state.borrowerOneTimePaymentsHistory.status = loadingTypes.failed;
    });

    builder.addCase(fetchPayoffDemands.pending, (state) => {
      state.payOffDemands.data = [];
      state.payOffDemands.status = loadingTypes.loading;
    });
    builder.addCase(fetchPayoffDemands.fulfilled, (state, action) => {
      state.payOffDemands.data = action.payload;
      state.payOffDemands.status = loadingTypes.fulfilled;
       state.pendingLenderApproval = action.payload?.filter(
        (el) => el.status === "Pending Lender Approval",
      )?.length;
    });
    builder.addCase(fetchPayoffDemands.rejected, (state) => {
      state.payOffDemands.data = [];
      state.payOffDemands.status = loadingTypes.failed;
      state.pendingLenderApproval = 0
    });

    builder.addCase(fetchPayoffDemandsDetail.pending, (state) => {
      state.payOffDemandsDetail.data = [];
      state.payOffDemandsDetail.status = loadingTypes.loading;
    });
    builder.addCase(fetchPayoffDemandsDetail.fulfilled, (state, action) => {
      state.payOffDemandsDetail.data = action.payload;
      state.payOffDemandsDetail.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchPayoffDemandsDetail.rejected, (state) => {
      state.payOffDemandsDetail.data = [];
      state.payOffDemandsDetail.status = loadingTypes.failed;
    });

    builder.addCase(fetchBorrowerOtherDetails.pending, (state) => {
      state.borrowerOtherDetails.data = [];
      state.borrowerOtherDetails.status = loadingTypes.loading;
    });
    builder.addCase(fetchBorrowerOtherDetails.fulfilled, (state, action) => {
      state.borrowerOtherDetails.data = action.payload;
      state.borrowerOtherDetails.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchBorrowerOtherDetails.rejected, (state) => {
      state.borrowerOtherDetails.data = [];
      state.borrowerOtherDetails.status = loadingTypes.failed;
    });

    builder.addCase(fetchVOMRequests.pending, (state) => {
      state.vomRequests.data = [];
      state.vomRequests.status = loadingTypes.loading;
    });
    builder.addCase(fetchVOMRequests.fulfilled, (state, action) => {
      state.vomRequests.data = action.payload;
      state.vomRequests.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchVOMRequests.rejected, (state) => {
      state.vomRequests.data = [];
      state.vomRequests.status = loadingTypes.failed;
    });

    builder.addCase(fetchVOMRequestDetails.pending, (state) => {
      state.vomRequestDetail.data = [];
      state.vomRequestDetail.status = loadingTypes.loading;
    });
    builder.addCase(fetchVOMRequestDetails.fulfilled, (state, action) => {
      state.vomRequestDetail.data = action.payload;
      state.vomRequestDetail.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchVOMRequestDetails.rejected, (state) => {
      state.vomRequestDetail.data = [];
      state.vomRequestDetail.status = loadingTypes.failed;
    });

    builder.addCase(fetchUSStates.pending, (state) => {
      state.USstates.data = [];
      state.USstates.status = loadingTypes.loading;
    });
    builder.addCase(fetchUSStates.fulfilled, (state, action) => {
      state.USstates.data = action.payload;
      state.USstates.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchUSStates.rejected, (state) => {
      state.USstates.data = [];
      state.USstates.status = loadingTypes.failed;
    });

    builder.addCase(fetchVOMRequestsForBorrower.pending, (state) => {
      state.borrowerVOMRequests.data = [];
      state.borrowerVOMRequests.status = loadingTypes.loading;
    });
    builder.addCase(fetchVOMRequestsForBorrower.fulfilled, (state, action) => {
      state.borrowerVOMRequests.data = action.payload;
      state.borrowerVOMRequests.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchVOMRequestsForBorrower.rejected, (state) => {
      state.borrowerVOMRequests.data = [];
      state.borrowerVOMRequests.status = loadingTypes.failed;
    });

    builder.addCase(fetchPayoffDemandsThirdParty.pending, (state) => {
      state.thirdPartyPayoffRequests.data = [];
      state.thirdPartyPayoffRequests.status = loadingTypes.loading;
    });
    builder.addCase(fetchPayoffDemandsThirdParty.fulfilled, (state, action) => {
      state.thirdPartyPayoffRequests.data = action.payload;
      state.pendingAuthPayoffCount = action.payload?.filter(
        (el) => el.status === "PENDING",
      )?.length;
      state.thirdPartyPayoffRequests.status = loadingTypes.fulfilled;
    });
    builder.addCase(fetchPayoffDemandsThirdParty.rejected, (state) => {
      state.thirdPartyPayoffRequests.data = [];
      state.thirdPartyPayoffRequests.status = loadingTypes.failed;
      state.pendingAuthPayoffCount = 0;
    });
  },
});

export const {
  setDashboardStatus,
  setPieSelected,
  setRevYTDPieStatus,
  setMeterDetails,
  resetDashboard,
  setLoanAgingTab,
  setLangugeDetected,
  handleTermsPopup,
  setActiveLoanStatus,
  resetAllAccountsLoanDetails,
  resetAllLoanBankDetails,
  setSmallDoughnutTableParentTab,
} = dashboardSlice.actions;

export default latestRequestOnly(dashboardSlice.reducer);
